<template>
    <div class="row">
        <div class="col-12">
            <card>
                <div class="card-body">
                    <div slot="raw-content" class="table-responsive">
                        <v-server-table
                            ref="vuetable"
                            url="/dtable/documents"
                            :columns="columns"
                            :options="options"
                        >
                            <template slot="beforeFilter">
                                <h2>
                                    <i class="fas fa-copy text-primary"></i> {{$t('document.title')}}
                                </h2>
                            </template>
                            <template slot="afterLimit">
                                <router-link
                                    v-if="isAdmin"
                                    class="btn btn-primary ml-2"
                                    :to="{ name: 'documents_new' }"
                                >
                                    <i class="fas fa-plus fa-fw"></i> {{$t('document.button.addnew')}}
                                </router-link>
                            </template>
                            <template slot="description" slot-scope="props">
                                <span
                                    :title="props.row.description"
                                >{{ truncateString(props.row.description, 50) }}</span>
                            </template>
                            <template slot="filename" slot-scope="props">
                                <a
                                    href
                                    class="text-primary"
                                    @click.prevent="getDownload(props.row)"
                                >{{ props.row.oldname }}</a>
                            </template>
                            <template slot="id" slot-scope="props" class="btn-group" role="group">
                                <a
                                    href
                                    class="btn btn-xs btn-primary mr-1"
                                    @click.prevent="getDownload(props.row)"
                                >
                                    <i class="fas fa-file-download fa-fw"></i>
                                </a>

                                <router-link
                                    v-if="isAdmin"
                                    class="btn btn-xs btn-primary mr-1"
                                    :to="{ name: 'documents_delete', params: { id: props.row.id } }"
                                >
                                    <i class="fas fa-trash-alt fa-fw"></i>
                                </router-link>
                            </template>
                        </v-server-table>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("documents", {
      documents: "all"
    }),
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  data() {
    return {
      columns: ["title", "description", "filename", "created_at", "id"],
      options: {
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          title: () => this.$t('document.titlec'),
          description: () => this.$t('document.description'),
          filename: () => this.$t('document.filename'),
          created_at: () => this.$t('document.createdat'),
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        orderBy: {
          ascending: false,
          column: "created_at"
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  methods: {
    truncateString(str, num) {
      if (str) {
        if (str.length <= num) {
          return str;
        }
        return str.slice(0, num) + "...";
      } else {
        return "";
      }
    },
    getDownload(obj) {
      this.$store.dispatch("documents/download", obj);
    }
  }
};
</script>
<style>
</style>
